// extracted by mini-css-extract-plugin
export default {"dialog":"dialog_dialog__GBEgx","content":"dialog_content__L9Cv8","fullWidth":"dialog_fullWidth__m53iB"};